import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'

const Comments = ({commets}) => {
 
    
  return (
    <Grid container width="100%" display={"flex"} flexDirection={"column"} gap={2} >
     
        {commets?.map((item,index) => 
            <Box key={index} border="1px solid #EF7C00" p="0 0 20px 0" bgcolor={"#000"}>
                <Box display={"flex"} justifyContent={"space-between"} bgcolor={"#EF7C00"} borderBottom={"1px solid #EF7C00"} p="10px">
                    <Typography color="#fff">{item.Name}</Typography>
                    <Typography color="#fff">{item.Date}</Typography>
                </Box>
                <Typography color="#fff" p="10px">{item.Text}</Typography>
                {item?.Reply?.length > 0 &&
                   <Grid item lg={11} xl={11} xs={11} sm={11} md={11} bgcolor={"#fff"} borderBottom={"1px solid #000"} borderRadius={"10px"} p="10px" m="auto">
                        <Typography fontWeight={"bold"} >{item.Reply}</Typography>
                    </Grid>
                }

            </Box>
        )}
    </Grid>
  )
}

export default Comments